import "./JanusEcho.css"
import adapter, {type IAdapter} from "webrtc-adapter"

declare global {
    interface Window {
        adapter: IAdapter
    }
}
window.adapter = adapter

export const JanusEcho = () => {

    // console.log("Initializing Janus")
    // JanusJS.init({
    //     debug: "all",
    //     callback: () => { console.log("Janus initialized") }
    // })
    //
    // const janus = new JanusJS({
    //     server: "wss://www.lonerx.online/janusws",
    //     apisecret: "janusrocks",
    //     success: () => { console.log("Connected to Janus websocket") }
    // })
    //
    // console.log("Created session:", janus.getSessionId())

    // const ws = new WebSocket("wss://www.lonerx.online/janusws", "janus-protocol")
    // ws.onopen = () => {
    //     console.log("Connected to Janus websocket server")
    //
    //     openSession()
    // }
    // ws.onerror = () => {
    //     console.log("Error while connecting to Janus websocket server")
    // }
    // ws.onclose = () => {
    //     console.log("Connection to Janus websocket server has been closed")
    // }
    // ws.onmessage = (msg) => {
    //     console.log("Message from Janus:", msg)
    // }
    //
    // function openSession() {
    //     console.log("Trying to establish a session")
    //     // const message = {
    //     //
    //     // }
    // }

    // const janus = new Janus({
    //     server: "wss//lonerx.online/janusws",
    //     apisecret: "janusrocks",
    //     success: () => {
    //         console.log("Created session", janus.getSessionId())
    //     },
    //     error: (error) => {
    //         console.error("Failed to create session", error)
    //     },
    //     destroyed: () => {
    //         console.log("Session destroyed")
    //     }
    // })

    return (
        <p className="fade-in-out">Janus is working behind the scenes</p>
    )
}